/**
 * Medicion Entity - Metrology/Measurement station
 * Tracks measurements and quality control
 */
class Medicion {
    constructor() {
        this.measurementHistory = {};
    }

    /**
     * Record a measurement for a piece
     * @param {string} pieza - Piece name
     */
    measure(pieza) {
        const count = this.measurementHistory[pieza] || 0;
        this.measurementHistory[pieza] = count + 1;
    }

    /**
     * Get measurement count for a specific piece
     * @param {string} pieza - Piece name
     * @returns {number} - Number of measurements
     */
    getMeasurementCount(pieza) {
        return this.measurementHistory[pieza] || 0;
    }

    /**
     * Get all measurement history
     * @returns {Object}
     */
    getHistory() {
        return { ...this.measurementHistory };
    }

    /**
     * Get current state
     * @returns {Object}
     */
    getState() {
        return this.getHistory();
    }

    /**
     * Reset measurement history
     */
    reset() {
        this.measurementHistory = {};
    }
}

// Universal export (Node.js + React)
if (typeof module !== 'undefined' && module.exports) {
    module.exports = Medicion;
}
export default Medicion;
